<template>
  <v-container fill-height align-start :class="$vuetify.theme.dark?'grey-darken-3 pa-2 ':'white pa-2'">
    <v-row >
      <v-col cols="12" justify="center" v-if="hasStripe&&!payoutsEnabled " class="info mb-2">
        <v-row align="center" justify="center" no-gutters>
          <v-col cols="12" md="10">
            <v-list-item dense to="/stripe-registration" color="error">
              <v-list-item-avatar tile class="px-0">
                <v-icon color="white">info_outline</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-row no-gutters>
                  <span :class="`${$vuetify.breakpoint.mdAndUp?'body-1':'caption'} white--text`" >{{$language.jobDetails['Pending Stripe']}}</span>
                  <v-progress-circular indeterminate v-if="(userProfile.balances || false).waitingForUrl || false" class="pl-2" color="white"></v-progress-circular>
                </v-row>
              </v-list-item-content>
            </v-list-item>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row align="center" justify="center" v-if="!hasStripe && (userProfile || {}).acceptedReferralTerms" >
      <v-col cols="10" lg="8" align="center">
        <v-img width="200px" height="75px" :src="`${ require('@/assets/stripe-logo-blue.svg') }`"></v-img>
      </v-col>
      <v-col cols="8" class="py-4">
            <div class="grey--text text--darken-2 mb-3">
              <span class="body-1">
                A Stripe account is required to become part of the referral network. Please got to the stripe sign-up page and you will be guided through the process.
              </span>
            </div>
          </v-col>
      <v-col cols="10" lg="5" v-if="userProfile.stripeAuthStatus ==='pending'">
        {{ $language.registration["Pending Authorization"] }}
        <v-progress-linear indeterminate></v-progress-linear>
      </v-col>
      <v-col cols="10">
        <div class="mt-3 subheading text-center font-weight-bold grey--text" v-if="hasStripe">
          {{$language.registration["First stripe step complete"] }}
        </div>
        <div class="mt-3 subheading text-center font-weight-bold grey--text text-left" v-if="hasStripe">
          {{$language.registration["Stripe complete"] }}
        </div>
      </v-col>
      <v-col cols="10">
        <v-btn v-if="!hasStripe&&userProfile.stripeAuthStatus !=='pending'" @click="stripeSignup" block large color="primary">
          <span class="white--text">{{ $language.registration["Set up payments on stripe"] }}</span>
        </v-btn>
      </v-col>
    </v-row>
    <v-row align="center" justify="center" v-if="!(userProfile || {}).acceptedReferralTerms && !showTerms">
      <v-col cols="11" lg="8">
        <div class="text-xs-left mb-3">
          <span class="headline grey--text text--darken-3">Earn Passive Income</span>
        </div>
        <div class="grey--text text--darken-2 mb-3">
          <span class="body-1">Hefe’s unique referral system pays you a commission <b>every time</b> someone you refer works.<br /><br />
            <b>When they get paid, you get paid.</b> When they earn more, you earn more. If you refer both the company and the worker, you get a double pay day. And if they refer others, you get a piece of the action as well. Earn when you are not
            working.<br /><br />
            <b>Simple, Powerful and Lucrative.</b><br /><br />

          </span>
        </div>
        <div>
          <v-btn block depressed color="primary" style="height: 55px" @click="showTerms = true">Sign me up</v-btn>
        </div>
      </v-col>
    </v-row>
    <v-layout column align-center>

      <v-row v-if="showTerms&& !(userProfile || {}).acceptedReferralTerms" align="center" justify="center">
        <v-col cols="11" lg="8">
          <v-row align="stretch" justify="center" class="" no-gutters>
            <v-card outlined class="overflow-y-auto " :max-height="`calc(${$vuetify.breakpoint.height}px - 270px)`">
              <VCardText class=pa-2>
                <span class="body-1">
                  <b>REFERRAL PROGRAM TERMS AND CONDITIONS</b><br />
                  <b>Last Updated: May 5, 2020</b><br /><br />

                  This Hefe Services Agreement (“Agreement”) is a legal agreement between Hefe Technologies, Inc. (“Hefe”, “HefeApp.com”, “GetHefe.com”, “Kuote.com”, “us”, “our”, or “we”) and the entity or person (“you”, “your”, “contractor”, or “user”) who
                  registered on the Hefe Account page to receive temporary use software as a service in both downloadable and non-downloadable forms in the field of staffing and employment, contracting, sub-contracting; Enabling and facilitating the posting
                  of work opportunities, searching, building contact lists, application, screening, negotiation, booking, onboarding, communications, timecards, payment, ratings, data, technology and analytics services, and other business services that may be
                  offered by Hefe and its affiliates (each, a “Service”). This Agreement describes the terms and conditions that apply to your use of the Referral Commission System.<br /><br />

                  If you do not understand and of the terms of this Agreement, please contact us before using our service.<br /><br />

                  <b>YOU MAY NOT ACCESS OR USE THIS SERVICE UNLESS YOU AGREE TO ABIDE BY ALL OF THE TERMS AND CONDITIONS IN THIS AGREEMENT.</b><br /><br />

                  <b>GENERAL TERMS</b><br />
                  Your use of Hefe constitutes your agreement to all such Terms. Please read these terms carefully, and keep a copy of them for your reference.<br /><br />

                  <b>INDEPENDENT CONTRACTOR AGREEMENT</b><br />
                  It is understood by the parties that the Contractor is an independent contractor with respect to the Recipient, and not an employee of the Hefe Technologies. The Recipient will not provide fringe benefits, including health insurance
                  benefits, paid vacation, or any other employee benefit, for the benefit of the Contractor.<br /><br />

                  It is contemplated that the relationship between the Contractor and the Recipient shall be a non-exclusive one. The Contractor also performs services for other organizations and/or individuals. The Recipient has no right to further inquire
                  into the Contractor's other activities.<br /><br />

                  <b>DESCRIPTION OF SERVICES</b><br />
                  The Contractor will provide the following services (collectively, the “Services") enrollment of workers and companies to the Hefe Platform. Contractor may provide adoption and user support of those parties that the contractor has enrolled to
                  the platform as it directly impacts their payment.<br /><br />

                  Furthermore, the Contractor has the right of control over how the Contractor will perform the services. The Recipient does not have this right of control over how the Contractor will perform the services.<br /><br />

                  <b>Referrers</b><br />
                  The first contractor to refer a new worker or company to Hefe that completes the enrollment process has first rights to the party and subsequent compensation for the referral.

                  <b>PAYMENT FOR SERVICES</b><br />
                  The Recipient will pay compensation to the Contractor for the Services. Payments will be initiated when transactions are settled between referred worker and the hiring business. Hefe relies on a 3rd Party Payment Platform (Stripe) that may
                  add a delay to when the money is deposited into the contractor’s financial account. The commission rates is based on a proprietary formula that may change at the discretion of Hefe Technologies.<br /><br />

                  Other fees and/or expenses will be paid to the Contractor, unless such fees and/or expenses have been approved in advance by the appropriate executive on behalf of the Recipient in writing. The Contractor shall be solely responsible for any
                  and all taxes, Social Security contributions or payments, disability insurance, unemployment taxes, and other payroll type taxes applicable to such compensation.<br /><br />

                  The Contractor has the right of control over the method of payment for services based on options available of the third party payment platform (Stripe). The third party payment platform has the right to collect additional information from
                  the Contractor is order to comply to Federal, State and Local requirements.<br /><br />

                  <b>TERM/TERMINATION</b><br />
                  This Agreement shall terminate automatically if the Contractor fails to fulfill the terms of this agreement. Furthermore, the Contractor has the ability to terminate this Agreement "at will."<br /><br />

                  A regular, ongoing relationship of indefinite term is not contemplated. The Recipient has no right to assign services to the Contractor other than as specifically contemplated by this Agreement. However, the parties may mutually agree that
                  the Contractor shall perform other services for the Recipient, pursuant to the terms of this Agreement.<br /><br />

                  <b>RECIPIENT'S CONTROL</b><br />
                  The Recipient has no right or power to control or otherwise interfere with the Contractor's mode of effecting performance under this Agreement. The Recipient's only concern is the result of the Contractor's work, and not the means of
                  accomplishing it. Except in extraordinary circumstances and when necessary, the Contractor shall perform the Services without direct supervision by the Recipient.<br /><br />

                  <b>PROFESSIONAL CAPACITY</b><br />
                  The Contractor is a professional who uses his or her own professional and business methods to perform services. The Contractor has not and will not receive training from the Recipient regarding how to perform the Services.<br /><br />

                  <b>PERSONAL SERVICES NOT REQUIRED</b><br />
                  The Contractor is not required to render the Services personally and may employ others to perform the Services on behalf of the Recipient without the Recipient's knowledge or consent. If the Contractor has assistants, it is the Contractor's
                  responsibility to hire them and to provide materials for them.<br /><br />

                  <b>NO LOCATION ON PREMISES</b><br />
                  The Contractor has no desk or other equipment either located at or furnished by the Recipient. Except to the extent that the Contractor works in a territory as defined by the Recipient, his or her services are not integrated into the
                  mainstream of the Recipient's business.<br /><br />

                  <b>NO SET WORK HOURS</b><br />
                  The Contractor has no set hours of work. There is no requirement that the Contractor work full time or otherwise account for work hours.<br /><br />

                  <b>EXPENSES PAID BY CONTRACTOR</b><br />
                  The Contractor's business and travel expenses are to be paid by the Contractor and not by the Recipient.<br /><br />

                  <b>OWNERSHIP OF SOCIAL MEDIA CONTACTS</b><br />
                  Any social media contacts, including "followers" or "friends," that are acquired through accounts (including, but not limited to email addresses, blogs, Twitter, Facebook, YouTube, or other social media networks) used or created on behalf of
                  the Recipient are the property of the Recipient.<br /><br />

                  <b>CONFIDENTIALITY</b><br />
                  Contractor may have had access to proprietary, private and/or otherwise confidential information ("Confidential Information") of the Recipient. Confidential Information shall mean all non-public information which constitutes, relates or
                  refers to the operation of the business of the Recipient, including without limitation, all financial, investment, operational, personnel, sales, marketing, managerial and statistical information of the Recipient, and any and all trade
                  secrets, customer lists, or pricing information of the Recipient. The nature of the information and the manner of disclosure are such that a reasonable person would understand it to be confidential. The Contractor will not at any time or in
                  any manner, either directly or indirectly, use for the personal benefit of the Contractor, or divulge, disclose, or communicate in any manner any Confidential Information. The Contractor will protect such information and treat the
                  Confidential Information as strictly confidential. This provision shall continue to be effective after the termination of this Agreement. Upon termination of this Agreement, the Contractor will return to the Recipient all Confidential
                  Information, whether physical or electronic, and other items that were used, created, or controlled by the Contractor during the term of this Agreement.<br /><br />

                  This Agreement is in compliance with the Defend Trade Secrets Act and provides civil or criminal immunity to any individual for the disclosure of trade secrets: (i) made in confidence to a federal, state, or local government official, or to
                  an attorney when the disclosure is to report suspected violations of the law; or (ii) in a complaint or other document filed in a lawsuit if made under seal.<br /><br />

                  <b>INJURIES</b><br />
                  The Contractor acknowledges the Contractor's obligation to obtain appropriate insurance coverage for the benefit of the Contractor (and the Contractor's employees, if any). The Contractor waives any rights to recovery from the Recipient for
                  any injuries that the Contractor (and/or Contractor's employees) may sustain while performing services under this Agreement and that are a result of the negligence of the Contractor or the Contractor's employees. Contractor will provide the
                  Recipient with a certificate naming the Recipient as an additional insured party.<br /><br />

                  <b>INDEMNIFICATION</b><br />
                  The Contractor agrees to indemnify and hold harmless the Recipient from all claims, losses, expenses, fees including attorney fees, costs, and judgments that may be asserted against the Recipient that result from the acts or omissions of the
                  Contractor, the Contractor's employees, if any, and the Contractor's agents.<br /><br />

                  <b>NO RIGHT TO ACT AS AGENT</b><br />
                  An "employer-employee" or "principal-agent" relationship is not created merely because (1) the Recipient has or retains the right to supervise or inspect the work as it progresses in order to ensure compliance with the terms of the contract
                  or (2) the Recipient has or retains the right to stop work done improperly. The Contractor has no right to act as an agent for the Recipient and has an obligation to notify any involved parties that it is not an agent of the Recipient.<br /><br />

                  <b>ENTIRE AGREEMENT</b><br />
                  This Agreement constitutes the entire contract between the parties. All terms and conditions contained in any other writings previously executed by the parties regarding the matters contemplated herein shall be deemed to be merged herein and
                  superseded hereby. No modification of this Agreement shall be deemed effective unless in writing and signed by the parties hereto.<br /><br />

                  <b>WAIVER OF BREACH</b><br />
                  The waiver by the Recipient of a breach of any provision of this Agreement by Contractor shall not operate or be construed as a waiver of any subsequent breach by Contractor.<br /><br />

                  <b>SEVERABILITY</b><br />
                  If any provision of this Agreement shall be held to be invalid or unenforceable for any reason, the remaining provisions shall continue to be valid and enforceable. If a court finds that any provision of this Agreement is invalid or
                  unenforceable, but that by limiting such provision it would become valid and enforceable, then such provision shall be deemed to be written, construed, and enforced as so limited.<br /><br />

                  <b>APPLICABLE LAW</b><br />
                  This Agreement shall be governed by the laws of the State of Delaware.<br /><br />

                  <b>CHANGES TO TERMS</b><br />
                  Hefe reserves the right, in its sole discretion, to change the Terms offered. The most current version of the Terms will supersede all previous versions. Hefe encourages you to periodically review the Terms to stay informed of our updates.<br /><br />

                  <b>ACCEPTANCE</b><br />
                  By clicking on accept, the Recipient is signing this agreement.<br /><br />

                </span>
              </VCardText>
            </v-card>
          </v-row>
          <v-col cols="12" class="pt-0">
            <v-row justify="center">
              <v-checkbox v-model="acceptedReferralTerms" hide-details color="primary">
                <div slot="label" :class="
                  ` ${
                    $vuetify.breakpoint.xs
                      ? 'body-2'
                      : $vuetify.breakpoint.sm
                      ? 'subheading'
                      : 'subheading'
                  }`">
                  {{ $language.registration["Accept User Terms and Conditions"] }}
                </div>
              </v-checkbox>
            </v-row>
          </v-col>
          <v-row align="center" no-gutters justify="center">
            <v-btn block large color="primary" @click="acceptTerms" :disabled="!acceptedReferralTerms">
              {{ $language.registration["Next"] }}
            </v-btn>
          </v-row>
        </v-col>
      </v-row>

      <v-flex xs12 v-if="(userProfile || {}).acceptedReferralTerms&& hasStripe">
        <v-layout column wrap pt-4 justify-start align-center pb-4 mb-4 class="text-xs-center">
          <v-flex xs12>
            <span class="headline">Refer Someone to Hefe</span>
          </v-flex>
          <v-flex xs12>
            <span class="subheading pb-4" v-if="!userProfile.referralShortLink">{{ $language.referrals['To begin, create a invite code.'] }}</span>
            <span class="subheading pb-4" v-else>{{ $language.referrals['Use the link below for all referrals.'] }}</span>
          </v-flex>
          <v-layout row v-if="!userProfile.referralShortLink&&!userProfile.pendingLink" pt-4>
            <v-text-field :class="`pt-2 pb-0 pr-1 custom ${hasId?'pl-4':''}`" dense label="Referral Id" v-model="userProfile.referralLinkId" @keydown.space.prevent @keyup="checkAvailability" maxlength="30" outlined solo flat>
            </v-text-field>
            <v-progress-circular color="primary" indeterminate class="mt-2 pl-1" v-if="pending"></v-progress-circular>
            <VIcon medium v-if="available&&!pending&&hasId" color="success">check</VIcon>
            <VIcon medium color="red" v-if="!available&&!pending&&hasId">fa fa-times</VIcon>
          </v-layout>
          <v-btn color="primary" @click="setCode" :disabled="!available" v-if="!userProfile.referralShortLink&&!userProfile.pendingLink&&available">Generate Link</v-btn>

          <v-flex xs12 class="py-2" v-if="userProfile.referralShortLink">
            <v-layout column justify-baseline align-center pt-4>
              <qrcode-vue :value="userProfile.referralShortLink" size="200" level="H"></qrcode-vue>

              <v-text-field outlined id="link" readonly :value="userProfile.referralShortLink" class="pt-8">
                <template v-slot:append>
                  <v-icon @click="copy">content_copy</v-icon>
                </template>
              </v-text-field>

              <v-btn color="primary" fab @click="share">
                <VIcon large>share</VIcon>
              </v-btn>
            </v-layout>

          </v-flex>
          <v-progress-circular color="primary" indeterminate size="70" v-if="userProfile.pendingLink" class="mt-4 pt-4"></v-progress-circular>
        </v-layout>
      </v-flex>

    </v-layout>

    <!-- <v-layout column justify-center align-center>
      <div class="mt-4 pt-4 text-xs-center" @click="rtosDialog = true">
        Referral Terms of Service
      </div>
    </v-layout>
    <v-dialog v-model="rtosDialog" scrollable fullscreen persistent :overlay="false" transition="dialog-transition">
      <v-card>
        <v-toolbar color="primary">
          <v-app-bar-nav-icon @click="rtosDialog = false">
            <v-icon>close</v-icon>
          </v-app-bar-nav-icon>
          <v-toolbar-title :class="`${$vuetify.breakpoint.mdAndUp?'headline':'title'}  font-weight-bold`">
            {{$language.referrals['ReferralsTos']}}
          </v-toolbar-title>
        </v-toolbar>
        <v-card outlined class="overflow-y-auto ma-2" :max-height="`calc(${$vuetify.breakpoint.height}px - 56px)`">

          <RTos></RTos>

        </v-card>
      </v-card>
    </v-dialog> -->
    <v-snackbar v-model="snackbar.show" :color="snackbar.status"  :timeout="1700">
      {{ snackbar.message }} <v-icon class="pl-4">check</v-icon>
    </v-snackbar>
  </v-container>
</template>
<script>
import {
  mapState
} from 'vuex'
import moment from 'moment'
import QrcodeVue from 'qrcode.vue'
// import RTos from '@/components/common/RTos'
const fb = require('@/services/firebaseConfig.js')

export default {
  components: {
    QrcodeVue
    // RTos
  },
  data () {
    return {
      snackbar: {
        show: false,
        message: '',
        status: 'success'
      },
      step: 1,
      showTerms: false,
      mobilePhone: null,
      valid: false,
      acceptedReferralTerms: false,
      available: false,
      pending: false,
      rtosDialog: false
    }
  },
  mounted: function () {
    if (this.$route.query.code) {
      var updates = {}
      updates[`user/${this.currentUser.uid}/profile/stripeCode`] = this.$route.query.code
      updates[`user/${this.currentUser.uid}/profile/stripeAuthStatus`] = 'pending'
      fb.database.ref().update(updates)
    }
    if (this.$route.query.stripeAuth) {
      // this.showTerms = true
    }
    setTimeout(() => {
      this.loading = false
    }, 1000)
  },
  computed: {
    ...mapState(['userProfile', 'currentUser']),
    hasId () {
      return (((this.userProfile || []).referralLinkId || []).length || false) > 0
    },
    hasStripe () {
      var pending = (((this.userProfile || {}).stripeAccount || {}).account || false)
      return pending
    },
    payoutsEnabled () {
      var pending = ((((this.userProfile || {}).stripeAccount || {}).account || {}).payouts_enabled || false)
      return pending
    }
  },
  methods: {
    stripeSignup () {
      // dev
      // window.location.href = `https://dashboard.stripe.com/express/oauth/authorize?response_type=code&client_id=ca_CNBjx860hxJ1ujCiC0yawQB6oyE0TFaH&stripe_user[first_name]=${this.userProfile.public.firstName}&stripe_user[last_name]=${this.userProfile.public.lastName}&stripe_user[email]=test${this.userProfile.public.email}&stripe_user[phone_number]=0000000000&scope=read_write&redirect_uri=http://localhost:8080/referrals?stripeAuth=true`
      // test
      // window.location.href = `https://dashboard.stripe.com/express/oauth/authorize?response_type=code&client_id=ca_CNBjx860hxJ1ujCiC0yawQB6oyE0TFaH&stripe_user[first_name]=${this.userProfile.public.firstName}&stripe_user[last_name]=${this.userProfile.public.lastName}&stripe_user[email]=test${this.userProfile.public.email}&stripe_user[phone_number]=0000000000&scope=read_write&redirect_uri=http://jefe-vue.firebaseapp.com/referrals?stripeAuth=true`
      // prod
      window.location.href = `https://dashboard.stripe.com/express/oauth/authorize?response_type=code&client_id=ca_CNBjvPagvg5ImtTPpEpbScvmuWig3SMS&stripe_user[first_name]=${this.userProfile.public.firstName}&stripe_user[last_name]=${this.userProfile.public.lastName}&stripe_user[email]=${this.userProfile.public.email}&stripe_user[phone_number]=${this.userProfile.public.mobilePhone}&scope=read_write&redirect_uri=https://hefeapp.com/referrals?stripeAuth=true`
    },
    copy () {
      var copyText = document.getElementById('link')

      copyText.select()
      copyText.setSelectionRange(0, 99999) /* For mobile devices */

      document.execCommand('copy')

      this.snackbar.status = 'info'
      this.snackbar.message = `${copyText.value} copied to clipboard!`
      this.snackbar.show = true
    },
    share () {
      if (navigator.share) {
        navigator.share({
          title: 'Hefe App',
          text: 'Check out Hefe. ',
          url: this.userProfile.referralShortLink
        })
          .then(() => console.log('Successful share'))
          .catch((error) => console.log('Error sharing', error))
      }
    },
    setCode () {
      var updates = {}
      updates[`/referralLink/${this.userProfile.referralLinkId}/${this.currentUser.uid}`] = true
      updates[`/user/${this.currentUser.uid}/profile/referralLinkId`] = this.userProfile.referralLinkId
      updates[`/user/${this.currentUser.uid}/profile/pendingLink`] = true
      fb.database.ref().update(updates)
    },
    checkAvailability () {
      if ((((this.userProfile || []).referralLinkId || []).length || false)) {
        this.userProfile.referralLinkId = this.userProfile.referralLinkId.toUpperCase()
        this.pending = true
        clearTimeout(this._timerId)
        // delay new call 500ms
        this._timerId = setTimeout(() => {
          return fb.database.ref(`referralLink/${this.userProfile.referralLinkId}`).once('value').then((response) => {
            this.available = response.val() == null
            this.pending = false
          }).catch((error) => {
            this.available = false
            this.pending = false
            console.log(error)
          })
        }, 500)
      } else {
        this.available = false
        this.pending = false
      }
    },
    acceptTerms () {
      this.showTerms = false
      fb.database.ref(`user/${this.currentUser.uid}/profile/acceptedReferralTerms`).set(true)
    },

    sendInvite () {
      if (this.mobilePhone !== null && this.mobilePhone.length === 10) {
        var invite = {
          'mobilePhone': this.mobilePhone,
          'inviteURL': this.userProfile.referralShortLink,
          'invitedBy': this.userProfile.public.name,
          'creationDate': new Date()
        }
        var inviteKey = fb.database.ref().child(`/user/${this.currentUser.uid}/profile/invites`).push().key
        var updates = {}
        updates[`/user/${this.currentUser.uid}/profile/invites/${inviteKey}`] = invite
        fb.database.ref().update(updates)
        this.snackbar.message = `Invite Sent to ${this.mobilePhone}`
        this.snackbar.show = true
        this.snackbar.status = 'success'
        this.mobilePhone = null
      } else {
        this.snackbar.message = `Mobile Phone Number is incorrect`
        this.snackbar.show = true
        this.snackbar.status = 'error'
      }
    }
  },
  watch: {
    mobilePhone () {
      if ((this.mobilePhone || {}).length === 10) {
        this.valid = true
      } else {
        this.valid = false
      }
    }
  },
  filters: {
    formatDate (val) {
      if (!val) {
        return '-'
      }
      let date = val.toDate()
      return moment(date).fromNow()
    },
    trimLength (val) {
      if (val.length < 200) {
        return val
      }
      return `${val.substring(0, 200)}...`
    }
  }
}
</script>
<style scoped>
>>> .custom.v-text-field.v-text-field--solo .v-input__control {
  height: 48px;
}
</style>
